import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

const BillingCancel = () => (
  <div className="min-h-screen bg-background flex items-center justify-center p-6">
    <div className="max-w-2xl w-full flex flex-col items-center text-center" data-testid="billing-cancel-page">
      <XCircle className="w-16 h-16 text-foreground/60 mb-6" strokeWidth={1.5} />
      <div className="text-xs uppercase tracking-[0.3em] text-foreground/60 mb-3">Pagamento Cancelado</div>
      <h1 className="font-heading text-5xl font-black tracking-tighter mb-6">Nenhuma cobrança realizada</h1>
      <p className="text-base text-foreground/70 max-w-md mb-8">
        Você cancelou o checkout. Sua assinatura permanece como está. Você pode tentar novamente
        a qualquer momento.
      </p>
      <Link to="/admin">
        <Button className="rounded-none h-12 px-8 uppercase tracking-[0.2em]" data-testid="billing-cancel-back">
          <ArrowLeft className="w-4 h-4 mr-2" /> Voltar ao Admin
        </Button>
      </Link>
    </div>
  </div>
);

export default BillingCancel;
